import React, {useState} from "react";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import HomeIcon from '@mui/icons-material/Home';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import './styless.scss'
import {useLocation, useNavigate} from "react-router-dom";
import {createBoard} from "../../api/boardManage";
import {fetchBoardListAsync, setSelectBoardType} from "../../store/boardSlice";
import {AppDispatch} from "../../store";
import {useDispatch} from "react-redux";
import {setLocalStorage} from "../../util/storage";
import {useTranslation} from "react-i18next";
import {useMatomoTrackingPoint} from "../../hooks/useMatomoTrackingPoint";
import {getUserInfo} from "../../util/author";
import BlogPanel from "./BlogPanel";
import {useThemeImage} from "../../hooks/useThemeImage";

export default function Navigation() {

    const logo = useThemeImage('logo');

    const location = useLocation();

    const navigate = useNavigate();

    const { t } = useTranslation()

    const [createLoading, setCreateLoading] = useState(false)

    const dispatch: AppDispatch = useDispatch();

    const {trackBoardSelectionPopupShow, trackSidebarHomeClick, trackBoardSpaceClick} = useMatomoTrackingPoint()

    const changeBoard = (boardId?: string, boardType?: "moodBoard" | "inspireBoard") => {
        setLocalStorage('boardId', boardId);
        const inspireQuery = boardType === 'inspireBoard' ? '&inspire=1' : '';
        navigate(`/?boardId=${boardId}${inspireQuery}`);
    }

    const createNewBoard = () => {
        if (createLoading) return
        setCreateLoading(true);
        createBoard({boardType: 'inspireBoard'}).then(item=>{
            changeBoard(item?.boardId, item?.boardType)
            setCreateLoading(false)
            dispatch(fetchBoardListAsync())
        })
    }

    const userInfo = getUserInfo()

    return <div style={{backgroundColor: 'var(--c-bg-tertiary)', height: 'calc(100vh - 60px)', borderRight: "1px solid var(--c-border)", padding: 10, boxSizing: "border-box", display: 'flex', flexDirection: 'column'}}>
        <img src={logo} alt='' style={{width: '160px'}} />
        <div style={{marginTop: 0, display: userInfo ? 'block' : 'none'}}>
            <div className='new-project' onClick={
                ()=>{
                    trackBoardSelectionPopupShow({board_selection_from: 'home_page'})
                    // dispatch(setSelectBoardType(true))
                    createNewBoard()
                }
            }><AddCircleIcon /> <span style={{marginLeft: 10}}>{t('NEW_PROJECT')}</span></div>
            <div
                className={`menu-item ${location.pathname === '/dashboard/home' ? 'menu-item-active' : ''}`}
                onClick={()=>{
                    trackSidebarHomeClick({ page_id: window.location.href });
                    navigate('/dashboard/home');
                }}
            >
                <HomeIcon /> <span style={{marginLeft: 10}}>{t('HOME')}</span>
            </div>
            <div
                 className={`menu-item ${location.pathname === '/dashboard' ? 'menu-item-active' : ''}`}
                 onClick={()=>{
                     trackBoardSpaceClick({ page_id: window.location.href, switch_from: 'sidebar' });
                     navigate('/dashboard');
                 }}
            ><FolderOpenOutlinedIcon /> <span style={{marginLeft: 10}}>绘板空间</span>
            </div>
        </div>
        {/*<div className='blog' style={{overflowY: 'auto', flex: 1, minHeight: 0, paddingLeft: 6}}><BlogPanel /></div>*/}
    </div>
}